import React from "react";
import { Accordion } from "./Accordion";
import { OBJECTIONS } from "../lib/data";
export function Objections() {
  return <section className="px-4 py-6" data-id="element-156" data-mp="rkde6hv628sv">
      <h2 className="mb-4 text-center text-xl font-black text-white" data-id="element-157" data-mp="rh7trfxhfv3h">
        ¿Tenés dudas? Te las respondemos
      </h2>
      <div className="space-y-2.5" data-id="element-158" data-mp="hl4nbxvllaaq">
        {OBJECTIONS.map(o => <Accordion key={o.q} header={o.q} data-id="element-159" data-mp="hn8rmgxesbbj">
            <p className="text-sm leading-snug text-slate-700" data-id="element-160" data-mp="cm1nqsydzwa5">{o.a}</p>
          </Accordion>)}
      </div>
    </section>;
}